
















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { IPolicy, PolicyFilter } from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import PoliciesOverview from '@/views/pages/policies/PoliciesOverview.vue';

import { PolicyApi } from '@/services/PolicyApi';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';

@Component({
  components: {
    PolicyStatusBadge,
    PoliciesOverview,
    XIcon,
  },
})
export default class PoliciesModal extends mixins(BaseMixin) {
  @Prop({ required: false })
  filter!: PolicyFilter & { columns: any[] };

  isLoading = false;

  policies: IPolicy[] = [];

  @Watch('filter')
  async watchFilter() {
    await this.reload();
  }

  async reload() {
    try {
      this.$Progress.start();
      this.isLoading = true;
      const response = await PolicyApi.getPolicies({
        users: this.filter.users,
        status: this.filter.status,
        agency: this.agency,
        isRelativeValue: this.filter.isRelativeValue!,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });
      this.policies = response.data;
      this.$Progress.finish();
      this.isLoading = false;
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
  }

  cancel() {
    //
  }

  get title() {
    let title = 'Anbahnungen: ';

    if (this.filter.users && this.filter.users.length > 0) {
      title += `${this.filter.users[0].firstname} ${this.filter.users[0].lastname}`;
    }

    return title;
  }
}
